import React, {useCallback} from 'react';
import Button from '@material-ui/core/Button';
import Snackbar from '@material-ui/core/Snackbar';
import theme from '../../../theme';

interface HighlightSnackbarProps {
    sidebar: MapSidebar;
    highlight: MapHighlight;
    onHighlightChange: (higlight: MapHighlight) => void;
    interaction: MapInteraction;
    isHighlightControlled: boolean;
}

export default function HighlightSnackbar({
    sidebar,
    highlight,
    onHighlightChange,
    interaction,
    isHighlightControlled,
}: HighlightSnackbarProps) {

    return <Snackbar
        style={{
            marginBottom: theme.spacing(3),
            left: '50%',
            right: 'auto',
            transform: 'translateX(-50%)',
            minWidth: 400
        }}
        anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
        }}
        open={(
            !isHighlightControlled &&
            Boolean(highlight) &&
            sidebar.type !== 'print' &&
            interaction.type !== 'editingRoute' &&
            interaction.type !== 'movingWaypoint'
        )}
        message={<div style={{fontSize: 14}}>
            You are highlighting one {highlight && highlight.type}
        </div>}
        action={<Button
            color="secondary"
            onClick={useCallback(
                () => onHighlightChange(undefined),
                [onHighlightChange]
            )}
            variant="outlined"
            style={{
                fontSize: 14,
                marginRight: theme.spacing(1),
                color: theme.palette.secondary.main,
                marginTop: theme.spacing(1),
                marginBottom: theme.spacing(1),
            }}
        >
            Exit highlight
        </Button>}
    />;
}
